import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const ActionsMobileContainer = styled.div`
  display: none;

  @media screen and (max-width: ${layout.md}) {
    display: block;
  }
`;

export const TopGrid = styled.div`
  display: grid;
  grid-column-gap: 8.6rem;
  justify-content: center;
  align-items: center;
  grid-template-columns: 396px 1fr;
  margin-bottom: 1rem;

  @media screen and (max-width: ${layout.subxlg}) {
    grid-column-gap: 3.3rem;
  }

  @media screen and (max-width: ${layout.lg}) {
    grid-template-columns: 300px 1fr;
  }

  @media screen and (max-width: ${layout.md}) {
    grid-template-columns: 1fr;
    grid-row-gap: 3.25rem;
    max-width: 400px;
    margin: 0 auto;

    .footer-form-container {
      grid-row: 3;
    }

    .footer-links-mobile-container {
      grid-row: 1;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    grid-row-gap: 3rem;
  }
`;
